






import markerIcon from '@/assets/images/marker.png';
import Vue from 'vue';
import * as leafLet from 'leaflet';
import 'leaflet/dist/leaflet.css';

export default Vue.extend({
  
  props: {
    styleObject:{
      type:Object,
      required:true
    },
    lat: {
      type: Number,
      required: true,
      default: 41.9028 
    },
    lng: {
      type: Number,
      required: true,
      default: 12.4964 
    }
  },
  data() {
    return {
      initialMap: null as L.Map | null,
      customIcon: null,
      marker:null,
      standardZoom: 18 as Number,
    };
  },
  mounted() {
    this.setMap();  
    
  },
  watch: {
    lat: 'updateMapPosition',
    lng: 'updateMapPosition',
  },
  methods: {
    setMap() {
       this.customIcon = new leafLet.Icon({
        iconUrl: markerIcon,
        iconSize: [50, 50], 
        popupAnchor: [-3, -76]
      });       
      
      this.initialMap = leafLet.map('map').setView([this.lat, this.lng], this.standardZoom);
      
      leafLet.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
      }).addTo(this.initialMap);
      
      this.marker =  leafLet.marker([this.lat, this.lng],{icon:this.customIcon}).addTo(this.initialMap);
      
      
      setTimeout(() => {
        this.initialMap?.invalidateSize();
        
      }, 500);
      
    },
    
    refreshMap() {      
      this.initialMap?.invalidateSize();
    },

    updateMapPosition() {
      if (this.initialMap && this.marker) {
        
        this.initialMap.setView([this.lat, this.lng], this.standardZoom);

        this.marker.setLatLng([this.lat, this.lng]);

      }
    },
    disableMapInteractions() {
      this.initialMap.dragging.disable();         
      this.initialMap.scrollWheelZoom.disable();  
      this.initialMap.touchZoom.disable();        
      this.initialMap.doubleClickZoom.disable();  
      this.initialMap.zoomControl.disable();      
    }
  }

});
